import React, { Component } from "react";

import AdminLink from "../app/AdminLink";

export default class Statistics extends Component {
  render() {
    return (
      <div className="statistics">
        <AdminLink />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/statistics/Statistics.js